<template>
	<div class="message-detail">
		<van-row v-if="info">
			<van-col span="24" class="title">{{info.title}}</van-col>
			<van-col span="24" class="time">{{info.updated_at}}</van-col>
			<van-col span="24" class="describe" v-html="info.content"></van-col>
		</van-row>
	</div>
</template>

<script>
import defaultImg from '@/assets/common/ListPreload.png';
export default {
  data() {
    return {
    	info: {},
		from: '',//传1代表从首页进来的，不需要token
		url: ''
    };
  },
  created(){
	  this.from = this.$route.query.from;
	  if(this.from == 1) {
		this.$api.setToken();
		this.url = '/cms/index/notice/detail';
	  }else {
		this.$api.setToken(this.$route.query.token);
		this.url = '/cms/member/notice/detail';
	  }
	  this.getRouterData()
  },
  methods: {
   	getRouterData() {
	    var ID = this.$route.query.id
		this.$api.get(this.url ,{id: ID}).then(res => {
	        this.info = res;
	    });
    },
  	nofind() {
	    var img = event.srcElement;
		img.src = defaultImg;
		img.onerror = null; //防止闪图
	}
  }
};
</script>

<style lang="less">
.message-detail {
	background: #F5F6F7;
	min-height: 100%;
	.title {
		color: #333;
		font-size: 16px;
		line-height: 22px;
		padding: 0 12px;
		margin-top: 6px;
	}
	.time {
		font-size: 12px;
		color: #999;
		margin: 2px 0 9px;
		height: 19px;
		line-height: 19px;
		padding: 0 12px;
	}
	.describe {
		img {
			width: 100%;
			display: block;
		}
	}
}



</style>
